import {
    UPDATE_RESTAURANT_DELIVERY_AREAS,
    UPDATE_RESTAURANT_DELIVERY_PERIODS,
    SWITCH_DELIVERY_TAB
} from '../types';
import api from '../api';

export const switchDeliveryTab = (tabIndex) => {
    return {
        type: SWITCH_DELIVERY_TAB,
        payload: tabIndex
    };
};

export const updateDeliveryAreas = (restId, areas) => {
    return {
        type: UPDATE_RESTAURANT_DELIVERY_AREAS,
        payload: api.restaurant.get(restId).deliveryAreas.update(areas),
        meta: { restId }
    };
};

export const updateDeliveryPeriods = (restId, hours, onSuccess) => {
    return {
        type: UPDATE_RESTAURANT_DELIVERY_PERIODS,
        payload: api.restaurant.get(restId).deliveryHours.update(hours),
        meta: { restId, onSuccess }
    };
};